import { FC } from "react";
import {
  DIALOG_FOOTER_CTAS_DEFAULTS,
  DIALOG_FOOTER_CTAS_DIRECTION_CLASS_MAP,
  DIALOG_FOOTER_CTA_DIRECTION_BUTTON_SIZE_MAP as DIALOG_FOOTER_CTA_DIRECTION_BUTTON_WIDTH_MAP,
  TDialogFooterCtaProps,
} from "./Dialog.config";
import { Button } from "../../primitives";
import { cn } from "@/ui/lib";

export const DialogFooterCtas: FC<TDialogFooterCtaProps> = ({
  align = DIALOG_FOOTER_CTAS_DEFAULTS.align, ctas,
}) => {
  if (!ctas) { return null; }
  return (
    <div
      data-component="DialogFooterCtas"
      className={cn(
        "flex gap-2",
        DIALOG_FOOTER_CTAS_DIRECTION_CLASS_MAP[align],
      )}
    >
      { ctas.primary ? (
        <Button {...ctas.primary} width={DIALOG_FOOTER_CTA_DIRECTION_BUTTON_WIDTH_MAP[align]} />
      ) : null }
      { ctas.secondary ? (
        <Button {...ctas.secondary} variant="tertiary" width={DIALOG_FOOTER_CTA_DIRECTION_BUTTON_WIDTH_MAP[align]} />
      ) : null }
    </div>
  );
};
